export class MenuModel{
    id: number;
    selected: boolean;
    menu: string;
    route: string;
    img: string;
    activeImg: string;
}